import StepContainer from '../components/layouts/StepContainer.vue';
import CardOption from '../components/options/CardOption.vue';
import optionMixin from './option';

export default {
  mixins: [optionMixin],

  props: ['stepNumber'],

  components: {
    CardOption,
    StepContainer
  }
}